export const rarities = [
    // {
    //     "tags": [],
    //     "total": 0,
    //     "found": 0,
    // }

    // * Uncommon
    {
        "tags": ["uncommon"],
        "total": "6,9M",
        "found": "170K",
    },
    {
        "tags": ["uncommon", "alpha"],
        "total": 628419,
        "found": "73K",
    },
    {
        "tags": ["uncommon", "alpha", "epoch0"],
        "total": 210000,
        "found": "16K",
    },
    {
        "tags": ["uncommon", "alpha", "2009"],
        "total": 32474,
        "found": 1232,
    },
    {
        "tags": ["uncommon", "alpha", "2009", "epoch0"],
        "total": 32474,
        "found": 1232,
    },
    {
        "tags": ["paliblock", "uncommon"],
        "total": 7925,
        "found": 216,
    },
    {
        "tags": ["paliblock", "uncommon", "alpha"],
        "total": 1602,
        "found": 130,
    },
    {
        "tags": ["paliblock", "uncommon", "alpha", "2009", "epoch0"],
        "total": 423,
        "found": 9,
    },
    {
        "tags": ["uncommon", "pali_uncommon"],
        "total": 1898,
    },
    {
        "tags": ["uncommon", "pali_uncommon", "paliblock"],
        "total": 169,
    },

    // * Uncommon, TZ
    {
        "tags": ["uncommon", "alpha", "epoch0", 'tz_10'],
        "total": 94416,
        "found": 7134,
    },
    {
        "tags": ["uncommon", "alpha", "epoch0", 'tz_11'],
        "total": 9434,
        "found": 729,
    },
    {
        "tags": ["uncommon", "alpha", "epoch0", 'tz_12'],
        "total": 941,
        "found": 68,
    },
    {
        "tags": ["uncommon", "alpha", "epoch0", 'tz_13'],
        "total": 94,
        "found": 5,
    },
    {
        "tags": ["uncommon", "alpha", "epoch0", 'tz_14'],
        "total": 9,
        "found": 2,
    },

    // * Black Uncommon
    {
        "tags": ["black_uncommon"],
        "total": "6,9M",
        "found": "87K",
    },
    {
        "tags": ["black_uncommon", "omega"],
        "total": 628419,
        "found": "46K",
    },
    {
        "tags": ["black_uncommon", "omega", "2009"],
        "total": 32474,
        "found": 995,
    },
    {
        "tags": ["black_uncommon", "omega", "epoch0"],
        "total": "210K",
        "found": "13K",
    },
    {
        "tags": ["black_uncommon", "paliblock"],
        "total": 7926,
        "found": 146,
    },
    {
        "tags": ["black_uncommon", "omega", "paliblock"],
        "total": 1642,
        "found": 108,
    },

    // * Palindrome
    {
        "tags": ["palindrome", "paliblock"],
        "total": 1740988,
        "found": 10056,
    },
    {
        "tags": ["palindrome", "paliblock", "nova"],
        "total": 10489,
        "found": 260,
    },
    // Palindrome 3D
    {
        "tags": ["palindrome", "3_digits"],
        "total": "1,2M",
        "found": "24K",
    },
    {
        "tags": ["palindrome", "3_digits", "sequence"],
        "total": 646183,
        "found": 13230,
    },
    {
        "tags": ["palindrome", "paliblock", "3_digits"],
        "total": 126465,
        "found": 898,
    },
    {
        "tags": ["palindrome", "3_digits", "paliblock", "sequence"],
        "total": 54383,
        "found": 566,
    },
    {
        "tags": ["palindrome", "3_digits", "nova"],
        "total": 70766,
        "found": 2871,
    },
    {
        "tags": ["palindrome", "3_digits", "nova", "sequence"],
        "total": 39422,
        "found": 1612,
    },
    // Palindrome 2D
    {
        "tags": ["palindrome", "2_digits"],
        "total": 30934,
        "found": 839,
    },
    {
        "tags": ["palindrome", "2_digits", "sequence"],
        "total": 23847,
        "found": 701,
    },
    {
        "tags": ["palindrome", "2_digits", "paliblock"],
        "total": 8571,
        "found": 76,
    },
    {
        "tags": ["palindrome", "2_digits", "paliblock", "sequence"],
        "total": 5924,
        "found": 65,
    },
    {
        "tags": ["palindrome", "2_digits", "nova"],
        "total": 1143,
        "found": 90,
    },
    {
        "tags": ["palindrome", "2_digits", "nova", "sequence"],
        "total": 954,
        "found": 75,
    },

    // * Uniform Palinception
    {
        "tags": ["uniform_palinception"],
        "total": 1850789,
        "found": 17635,
    },
    {
        "tags": ["uniform_palinception", "paliblock"],
        "total": 134098,
        "found": 2143,
    },
    {
        "tags": ["uniform_palinception", "paliblock", "sequence"],
        "total": 27173,
        "found": 710,
    },
    {
        "tags": ["uniform_palinception", "nova"],
        "total": 2040,
        "found": 135,
    },
    {
        "tags": ["uniform_palinception", "2009"],
        "total": 188900,
        "found": 1104,
    },
    {
        "tags": ["uniform_palinception", "2009", "paliblock"],
        "total": 48696,
        "found": 216,
    },
    // 3D
    {
        "tags": [ "uniform_palinception", "3_digits"],
        "total": 139616,
        "found": 4700,
    },
    {
        "tags": [ "uniform_palinception", "3_digits", "sequence"],
        "total": 76120,
        "found": 2866,
    },
    {
        "tags": [ "uniform_palinception", "3_digits", "paliblock"],
        "total": 25173,
        "found": 532,
    },
    {
        "tags": [ "uniform_palinception", "3_digits", "paliblock", "sequence"],
        "total": 9109,
        "found": 358,
    },
    // 2D
    {
        "tags": [ "uniform_palinception", "2_digits"],
        "total": 8953,
        "found": 327,
    },
    {
        "tags": [ "uniform_palinception", "2_digits", "sequence"],
        "total": 6655,
        "found": 274,
    },
    {
        "tags": [ "uniform_palinception", "2_digits", "paliblock"],
        "total": 3649,
        "found": 46,
    },
    {
        "tags": [ "uniform_palinception", "2_digits", "paliblock", "sequence"],
        "total": 2253,
        "found": 40,
    },

    // * Perfect Palinception
    {
        "tags": ["perfect_palinception"],
        "total": 13305,
        "found": 335,
    },
    {
        "tags": ["perfect_palinception", "2009"],
        "total": 11292,
        "found": 173,
    },
    {
        "tags": ["perfect_palinception", "nova"],
        "total": 1050,
        "found": 106,
    },
    {
        "tags": ["perfect_palinception", "paliblock"],
        "total": 1527,
        "found": 9,
    },
    // 3D
    {
        "tags": ["perfect_palinception", "3_digits"],
        "total": 6304,
        "found": 148,
    },
    {
        "tags": ["perfect_palinception", "3_digits", "sequence"],
        "total": 1448,
        "found": 33,
    },
    {
        "tags": ["perfect_palinception", "3_digits", "2009"],
        "total": 5225,
        "found": 70,
    },
    {
        "tags": ["perfect_palinception", "3_digits", "nova"],
        "total": 447,
        "found": 41,
    },
    {
        "tags": ["perfect_palinception", "3_digits", "nova", "sequence"],
        "total": 149,
        "found": 14,
    },
    // 2D
    {
        "tags": ["perfect_palinception", "2_digits"],
        "total": 1768,
        "found": 44,
    },
    {
        "tags": ["perfect_palinception", "2_digits", "sequence"],
        "total": 938,
        "found": 24,
    },
    {
        "tags": ["perfect_palinception", "2_digits", "2009"],
        "total": 1403,
        "found": 13,
    },
    {
        "tags": ["perfect_palinception", "2_digits", "nova"],
        "total": 63,
        "found": 8,
    },
    {
        "tags": ["perfect_palinception", "2_digits", "nova", "sequence"],
        "total": 45,
        "found": 4,
    },

    // * Pizza
    {
        "tags": ["pizza", "palindrome"],
        "total": 100016,
        "found": 4139
    },
    {
        "tags": ["pizza", "palindrome", "sequence"],
        "total": 12521,
        "found": 483,
    },
    {
        "tags": ["pizza", "palindrome", "3_digits"],
        "total": 391,
        "found": 13
    },
    {
        "tags": ["pizza", "palindrome", "3_digits", "sequence"],
        "total": 217,
        "found": 8
    },
    {
        "tags": ["pizza", "palindrome", "paliblock"],
        "total": 1530,
        "found": 45
    },
    {
        "tags": ["pizza", "uniform_palinception"],
        "total": 4130,
        "found": 147
    },
    {
        "tags": ["pizza", "uniform_palinception", "paliblock"],
        "total": 530,
        "found": 26
    },
    {
        "tags": ["palindrome", "pizza", "2009"],
        "total": 3000,
        "found": 381
    },
    {
        "tags": ["palindrome", "pizza", "pizza_2009"],
        "total": 3000,
        "found": 381
    },
    {
        "tags": ["palindrome", "pizza", "pizza_4/20"],
        "total": 1600,
    },
    // Pizza Alpha
    {
        "tags": ["alpha", "pizza"],
        "total": 10002,
        "found": 391
    },
    {
        "tags": ["alpha", "pizza", "2009"],
        "total": 300,
        "found": 22
    },
    {
        "tags": ["alpha", "pizza", "pizza_4/20"],
        "total": 160,
    },
    // Pizza Omega
    {
        "tags": ["omega", "pizza"],
        "total": 10000,
    },
    {
        "tags": ["omega", "pizza", "2009"],
        "total": 300,
    },
    {
        "tags": ["omega", "pizza", "pizza_4/20"],
        "total": 160,
    },

    // * Jpeg
    {
        "tags": ["jpeg", "palindrome"],
        "total": 5000,
        "found": 422,
    },
    {
        "tags": ["jpeg", "palindrome", "2009"],
        "total": 4500,
        "found": 395,
    },
    {
        "tags": ["jpeg", "palindrome", "jpeg_2010"],
        "total": 500,
        "found": 27,
    },
    {
        "tags": ["alpha", "jpeg"],
        "total": 500,
        "found": 35,
    },
    {
        "tags": ["alpha", "jpeg", "2009"],
        "total": 450,
        "found": 32,
    },
    {
        "tags": ["alpha", "jpeg", "jpeg_2010"],
        "total": 50,
        "found": 3,
    },
    {
        "tags": ["omega", "jpeg"],
        "total": 500,
        "found": 33,
    },
    {
        "tags": ["omega", "jpeg", "2009"],
        "total": 450,
        "found": 31,
    },
    {
        "tags": ["omega", "jpeg", "jpeg_2010"],
        "total": 50,
        "found": 2,
    },
    {
        "tags": ["jpeg", "uncommon", "alpha", "2009", "epoch0", "tz_10"],
        "total": 2,
    },

    // * Hitman
    {
        "tags": ["hitman", "palindrome"],
        "total": 16521,
        "found": 1079,
    },
    {
        "tags": ["hitman", "palindrome", "sequence"],
        "total": 2033,
        "found": 136,
    },
    {
        "tags": ["hitman", "alpha"],
        "total": 1662,
        "found": 103,
    },
    {
        "tags": ["hitman", "alpha", "vintage"],
        "total": 2,
        "found": 1,
    },
    {
        "tags": ["hitman", "omega"],
        "total": 1669,
        "found": 102,
    },

    // * Silkroad
    {
        "tags": ["silkroad", "palindrome"],
        "total": 198593,
        "found": 3138,
    },
    {
        "tags": ["silkroad", "palindrome", "sequence"],
        "total": 28083,
        "found": 446,
    },
    {
        "tags": ["silkroad", "alpha"],
        "total": 29542,
        "found": 586,
    },
    {
        "tags": ["silkroad", "omega"],
        "total": 29560,
        "found": 561,
    },

    // * Nakamoto
    {
        "tags": ["nakamoto", "palindrome"],
        "total": 77000,
        "found": 1037,
    },
    {
        "tags": ["nakamoto", "alpha"],
        "total": 950,
        "found": 67,
    },
    {
        "tags": ["nakamoto", "omega"],
        "total": 950,
        "found": 66,
    },

    // * Vintage
    {
        "tags": ["vintage", "alpha"],
        "total": 50000,
        "found": 286,
    },
    {
        "tags": ["vintage", "omega"],
        "total": 50000,
        "found": 285,
    },
    {
        "tags": ["vintage", "palindrome"],
        "total": "6M",
        "found": "21K",
    },
    {
        "tags": ["vintage", "palindrome", "paliblock"],
        "total": "1,1M",
        "found": "2K",
    },
    {
        "tags": ["vintage", "palindrome", "3_digits"],
        "total": 244800,
        "found": 457,
    },
    {
        "tags": ["vintage", "palindrome", "3_digits", "paliblock"],
        "total": 99680,
        "found": 115,
    },

    // * B9
    {
        "tags": ["block_9", "palindrome"],
        "total": 50000,
        "found": 28,
    },
    {
        "tags": ["450x", "palindrome"],
        "total": 1000,
        "found": 23,
    },

    // * B78
    {
        "tags": ["block_78", "alpha"],
        "total": 50,
        "found": 15,
    },
    {
        "tags": ["block_78", "palindrome"],
        "total": 5000,
        "found": 1462,
    },
    {
        "tags": ["block_78", "palindrome", "sequence"],
        "total": 545,
        "found": 165,
    },
    {
        "tags": ["block_78", "palindrome", "3_digits"],
        "total": 260,
        "found": 118,
    },
    {
        "tags": ["block_78", "palindrome", "2_digits"],
        "total": 8,
        "found": 5,
    },
    {
        "tags": ["block_78", "uniform_palinception"],
        "total": 104,
        "found": 45,
    },
    {
        "tags": ["block_78", "uniform_palinception", "sequence"],
        "total": 10,
        "found": 5,
    },
    {
        "tags": ["block_78", "uniform_palinception", "2_digits", "sequence"],
        "total": 2,
        "found": 1,
    },
    {
        "tags": ["block_78", "perfect_palinception"],
        "total": 5,
        "found": 1,
    },

    // * Alpha
    {
        "tags": ["2009", "alpha"],
        "total": 1624500,
        "found": 8241,
    },

    // * Omega
    {
        "tags": ["2009", "omega"],
        "total": 1624500,
        "found": 7887,
    },

    // * Rodarmor
    {
        "tags": ["rodarmor_name"],
        "total": "12,450",
        "found": "1K",
    },
    {
        "tags": ["rodarmor_name", "2009"],
        "total": 793,
        "found": 15,
    },
    {
        "tags": ["rodarmor_name", "paliblock"],
        "total": 29,
        "found": 0,
    },
    {
        "tags": ["rodarmor_name", "pizza"],
        "total": 43,
        "found": 0,
    },

    // * Other

];

const exception_tags = ['3-3-3-3', '3-3-3-3-3', '4-4-4-4', '5-5-5', '7-7', '8-8'];

const mandatory_subtags = {
    'perfect_palinception': ['palindrome', 'uniform_palinception'],
    'uniform_palinception': ['palindrome'],
    'vintage': ['2009'],
    'block_9': ['vintage', '2009', 'nakamoto'],
    'block_78': ['vintage', '2009'],
    'block_286': ['vintage', '2009'],
    '450x': ['block_9', 'vintage', '2009', 'nakamoto'],
    'pizza_2009': ['2009'],
    'nakamoto': ['2009'],
};

export function getSupply(tags) {
  // Create a Set to avoid duplicates
  let expandedTags = new Set(tags);

  // --- Expansion Step ---
  // For each tag that has mandatory subtags, add those subtags.
  tags.forEach(tag => {
    if (mandatory_subtags[tag]) {
      mandatory_subtags[tag].forEach(subtag => expandedTags.add(subtag));
    }
  });

  // --- Collapse Step ---
  // If a parent tag is present, remove its mandatory subtags so that the canonical form is used.
  Object.keys(mandatory_subtags).forEach(parent => {
    if (expandedTags.has(parent)) {
      mandatory_subtags[parent].forEach(subtag => expandedTags.delete(subtag));
    }
  });

  // Convert the Set back to an array, filter out any exception tags, and sort the result.
  const filteredTags = [...expandedTags]
    .filter(tag => !exception_tags.includes(tag))
    .sort();

  // Compare the resulting sorted tags with each rarity’s tags (which should also be in canonical form)
  for (const rarity of rarities) {
    const sortedRarityTags = [...rarity.tags].sort();
    if (JSON.stringify(sortedRarityTags) === JSON.stringify(filteredTags)) {
      return rarity;
    }
  }

  return null;
}

export function getFormattedSupply(tags) {
    // Retrieve the supply object (assuming getSupply is defined elsewhere)
    const supplyObject = getSupply(tags);
    if(supplyObject === null)
        return null;
  
    // Format the total and found values
    const formattedSupply = {
        ...supplyObject,
        total: renderTotalSupplyNumber(supplyObject.total),
      };
    if (supplyObject.found !== undefined) {
        formattedSupply.found = renderFoundSupplyNumber(supplyObject.found);
    }
    return formattedSupply;
  }

function renderTotalSupplyNumber(number) {

    // If the input is already a string, return it as is
    if (typeof number === 'string') {
        return number;
    }
  
    if (number < 60000) {
      return number.toLocaleString('en-US'); // Return the number as is if it's less than 60,000
    }
  
    if (number < 1000000) {
      // Format for thousands (K)
      const rounded = Math.round(number / 1000); // Round to the nearest thousand
      return `${rounded}K`;
    }
  
    // Format for millions (M)
    const rounded = Math.round(number / 100000) / 10; // Round to one decimal place
    return `${rounded}M`;
}

function renderFoundSupplyNumber(number) {

    // If the input is already a string, return it as is
    if (typeof number === 'string') {
        return number;
    }
  
    if (number <= 300) {
      return number.toString(); // Return the number as is if it's 300 or less
    }
  
    if (number < 1000) {
      // Round up to the nearest hundred for numbers between 300 and 999
      const rounded = Math.ceil(number / 100) * 100;
      return rounded.toString();
    }
  
    if (number < 1000000) {
      // Format for thousands (K)
      const rounded = Math.round(number / 1000); // Round to the nearest thousand
      return `${rounded}K`;
    }
  
    // Format for millions (M)
    const rounded = Math.round(number / 100000) / 10; // Round to one decimal place
    return `${rounded}M`;
}